<template>
  <div class="features-panel col-sm-12 col-lg-5 d-flex flex-column position-relative">
    <div
      class="features-bg position-absolute"
      :style="{ backgroundImage: `url(${bgImage})` }"
    />
    <div class="features-overlay position-absolute" />
    <div class="features-content position-relative d-flex flex-column flex-grow-1">
      <div class="features-logo-wrapper">
        <img
          :src="logoImage"
          alt="Oliverlist"
          class="features-logo"
        />
      </div>
      <div class="features-phrase-wrapper">
        <p class="features-phrase">
          {{ $t('lang.label.login-features-line1') }}<br>
          {{ $t('lang.label.login-features-line2') }}<br>
          {{ $t('lang.label.login-features-line3') }} <span class="features-phrase-strike mr-2">{{ $t('lang.label.login-features-leads') }}</span> <span class="features-phrase-highlight">{{ $t('lang.label.login-features-revenu') }}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bgImage: require("@/assets/images/login_image_revenue.png"),
      logoImage: require("@/assets/images/logo-h.png"),
    };
  },
};
</script>

<style scoped>
.features-panel {
  min-height: 100%;
  overflow: hidden;
  border-radius: 0 1rem 0 0;
}

.features-bg {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-size: cover;
  background-position: right center;
  background-repeat: no-repeat;
}

.features-overlay {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.45);
}

.features-content {
  padding: 2rem 2.5rem;
  min-height: 100%;
  justify-content: space-between;
}

.features-logo-wrapper {
  flex-shrink: 0;
}

.features-logo {
  max-height: 36px;
  width: auto;
  display: block;
}

.features-phrase-wrapper {
  flex: 1;
  display: flex;
  align-items: flex-end;
  padding-bottom: 2rem;
}

.features-phrase {
  font-family: 'PP Formula', sans-serif;
  font-weight: 700;
  font-size: clamp(1.5rem, 4vw, 2.25rem);
  line-height: 1.25;
  color: #fff;
  margin: 0;
  max-width: 90%;
}

.features-phrase-strike {
  color: #fff;
  text-decoration: line-through;
  text-decoration-color: #f4c430;
  text-decoration-thickness: 4px;
  font-weight: 700;
}

.features-phrase-highlight {
  color: #f4c430;
  font-weight: 700;
}

@media (max-width: 991px) {
  .features-panel {
    min-height: 40vh;
    border-radius: 0;
  }

  .features-content {
    padding: 1.5rem;
  }

  .features-phrase {
    font-size: 1.35rem;
  }
}
</style>
